import { RouteComponent, RouteRecordRaw } from 'vue-router';
import { reportRoutes } from '@/router/routes/report/report.routes';

export const routes: RouteRecordRaw[] = [
  {
    name: 'home',
    path: '/home',
    component: async (): Promise<RouteComponent> => await import('@/layouts/home-page/home-page.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'home' },
  },
  ...reportRoutes,
];
